export default __webpack_public_path__ + "static/boutique-9406c266d237b2d40b09c541f680c730.svg";